import {useNavigate} from 'react-router-dom';
import {NumericFormat as NumberFormat} from 'react-number-format';
import {useState} from 'react';
import {getSavedAnalyses, deleteSavedAnalysis} from '../savedAnalysesStorage';

function SavedAnalyses() {
    const navigate = useNavigate();
    const [, forceUpdate] = useState(0);
    const [confirmDeleteId, setConfirmDeleteId] = useState(null);
    const [deletingId, setDeletingId] = useState(null);
    const analyses = getSavedAnalyses();

    function handleDelete(id) {
        setDeletingId(id);
        setConfirmDeleteId(null);
        setTimeout(() => {
            deleteSavedAnalysis(id);
            setDeletingId(null);
            forceUpdate((n) => n + 1);
        }, 300);
    }

    return (
        <div className={'landing-container'}>
            <div className={'mt-50'}>
                <h3 className={'text-center'}>Saved Analyses</h3>
            </div>
            {analyses.length === 0 && (
                <div style={{textAlign: 'center', padding: '20px 0', color: '#999', marginTop: 20}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{marginBottom: 10, opacity: 0.6}}>
                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                        <polyline points="17 21 17 13 7 13 7 21"/>
                        <polyline points="7 3 7 8 15 8"/>
                    </svg>
                    <div style={{fontSize: 14}}>No saved analyses yet</div>
                    <div style={{fontSize: 12, marginTop: 4}}>Run an analysis and save it to compare later</div>
                    <button className={'primary'} style={{marginTop: 20}} onClick={() => navigate('/')}>
                        Analyse a property
                    </button>
                </div>
            )}
            <div style={{maxWidth: 500, width: '100%'}}>
                {analyses.map((a, i) => (
                    <div
                        key={a.id}
                        className={'pointer saved-row'}
                        onClick={() => deletingId ? null : navigate(`/saved/${a.id}`)}
                        style={{
                            padding: '12px 14px',
                            borderRadius: 8,
                            marginBottom: 6,
                            backgroundColor: '#1F3A5F',
                            border: '1px solid #2a4a6f',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 14,
                            animationDelay: `${i * 60}ms`,
                            ...(deletingId === a.id ? {
                                animation: 'fade-out-shrink 0.3s cubic-bezier(0.25, 1, 0.5, 1) forwards',
                            } : {}),
                        }}
                    >
                        <div style={{flex: 1}}>
                            <div style={{fontWeight: 600, marginBottom: 2}}>{a.name}</div>
                            <div style={{fontSize: 11, color: '#999'}}>
                                {new Date(a.savedAt).toLocaleDateString('en-ZA', {day: 'numeric', month: 'short', year: 'numeric'})}
                            </div>
                            <div style={{display: 'flex', alignItems: 'baseline', gap: 8, marginTop: 6, flexWrap: 'wrap'}}>
                                <NumberFormat
                                    value={a.summary.purchasePrice}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'R'}
                                    renderText={(value, props) => (
                                        <span {...props} style={{fontSize: 13, fontWeight: 600}}>{value}</span>
                                    )}
                                />
                                <span style={{color: '#555', fontSize: 11}}>|</span>
                                <NumberFormat
                                    value={Math.abs(a.summary.cumulativeCashFlow).toFixed(0)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'R'}
                                    renderText={(value, props) => (
                                        <span
                                            {...props}
                                            className={a.summary.cumulativeCashFlow >= 0 ? 'positive' : 'negative'}
                                            style={{fontSize: 13}}
                                        >
                                            {a.summary.cumulativeCashFlow >= 0 ? '+' : '-'}{value}
                                        </span>
                                    )}
                                />
                                <span style={{fontSize: 11, color: '#999'}}>
                                    after {a.summary.lastMonth} months
                                </span>
                            </div>
                        </div>
                        {confirmDeleteId === a.id ? (
                            <div onClick={(e) => e.stopPropagation()} className={'delete-confirm'} style={{display: 'flex', gap: 6}}>
                                <button
                                    onClick={() => handleDelete(a.id)}
                                    style={{
                                        background: '#FF4136',
                                        color: '#fff',
                                        boxShadow: 'none',
                                        fontSize: 11,
                                        padding: '4px 8px',
                                    }}
                                >
                                    Delete
                                </button>
                                <button
                                    onClick={() => setConfirmDeleteId(null)}
                                    style={{
                                        background: 'transparent',
                                        color: '#999',
                                        boxShadow: 'none',
                                        fontSize: 11,
                                        padding: '4px 8px',
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        ) : (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setConfirmDeleteId(a.id);
                                }}
                                style={{
                                    background: 'transparent',
                                    color: '#999',
                                    boxShadow: 'none',
                                    fontSize: 14,
                                    padding: '2px 8px',
                                }}
                            >
                                ✕
                            </button>
                        )}
                    </div>
                ))}
            </div>
            <div style={{marginTop: 20, marginBottom: 40}}>
                <span className={'pointer underline'} style={{fontSize: 14}} onClick={() => navigate('/landing')}>
                    Back to home
                </span>
            </div>
        </div>
    );
}

export default SavedAnalyses;
